import { Button, Chevron, FormCard, FormItem, Select, theme } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import useHomeType from 'hooks/useHomeType'
import type { ResidentItemExtended } from 'hooks/useResident'
import useZones from 'hooks/useZones'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'

const ZONES_SETTINGS_URL = '/settings/zones'
const PRO_ADVERT_URL = '/pro-advert'

type ZoneFormCardProps = { resident: ResidentItemExtended; testId?: string }

export const ZoneFormCard = ({ resident, testId }: ZoneFormCardProps) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  const { isPro } = useHomeType()
  const { zones } = useZones()
  const hasZones = zones?.length > 0
  const navigate = useNavigate()

  return (
    <FormCard testId={testId}>
      <FormItem
        label={<Text>{t(supConstants.ZONE)}</Text>}
        name="zone"
        extra={
          !hasZones &&
          isPro && (
            <>
              {t(supConstants.ZONE_EXTRA)}&nbsp;
              <Link to={ZONES_SETTINGS_URL}>
                {t(supConstants.ZONE_EXTRA_LINK)}
              </Link>
            </>
          )
        }
      >
        {isPro ? (
          <Select
            suffixIcon={
              <Chevron direction="down" color={theme.color.neutral.color5} />
            }
            defaultValue={zones.find((zone) => resident.zone === zone.id)?.name}
            options={zones?.map((zone) => ({
              label: <Text>{zone.name}</Text>,
              value: zone.id
            }))}
            disabled={!hasZones}
          />
        ) : (
          <Button variant="text" onClick={() => navigate(PRO_ADVERT_URL)}>
            {t(supConstants.VIEW_PRO_PLAN)}
            <Chevron direction="right" color={theme.color.status.primary} />
          </Button>
        )}
      </FormItem>
    </FormCard>
  )
}
